import React from 'react'

export const navigationStore = React.createContext({
  pathname: null,
  setPathname: () => {}
})
